import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    mode: 'light',
    primary: { main: '#1E3A8A', dark: '#172554', light: '#3B5BB7', contrastText: '#fff' },
    secondary: { main: '#F59E0B', dark: '#B45309', light: '#FBBF24', contrastText: '#1F1300' },
    success: { main: '#10B981', dark: '#047857', light: '#34D399' },
    error: { main: '#EF4444', dark: '#B91C1C', light: '#FCA5A5' },
    warning: { main: '#F97316', dark: '#C2410C', light: '#FDBA74' },
    info: { main: '#0EA5E9', dark: '#0369A1', light: '#7DD3FC' },
    background: { default: '#F8FAFC', paper: '#FFFFFF' },
    text: { primary: '#0F172A', secondary: '#475569', disabled: '#94A3B8' },
    divider: '#E2E8F0',
  },
  shape: { borderRadius: 12 },
  typography: {
    fontFamily:
      '"Inter","Plus Jakarta Sans","Segoe UI",system-ui,-apple-system,sans-serif',
    h1: { fontWeight: 800, letterSpacing: '-0.02em' },
    h2: { fontWeight: 800, letterSpacing: '-0.02em' },
    h3: { fontWeight: 700, letterSpacing: '-0.01em' },
    h4: { fontWeight: 700 },
    h5: { fontWeight: 600 },
    h6: { fontWeight: 600 },
    button: { fontWeight: 600, textTransform: 'none' },
  },
  components: {
    MuiButton: {
      defaultProps: { disableElevation: true },
      styleOverrides: { root: { borderRadius: 10, paddingInline: 18 } },
    },
    MuiPaper: {
      styleOverrides: { rounded: { borderRadius: 14 } },
    },
    MuiCard: {
      defaultProps: { elevation: 0 },
      styleOverrides: {
        root: { border: '1px solid #E2E8F0', borderRadius: 14 },
      },
    },
    MuiAppBar: { defaultProps: { color: 'inherit', elevation: 0 } },
    MuiTextField: { defaultProps: { size: 'small', fullWidth: true } },
    MuiOutlinedInput: { styleOverrides: { root: { borderRadius: 10 } } },
    MuiChip: { styleOverrides: { root: { borderRadius: 8, fontWeight: 600 } } },
    MuiTableCell: { styleOverrides: { head: { fontWeight: 700 } } },
  },
});

export default theme;
